import { Box, Typography, Accordion, AccordionSummary, AccordionDetails, Stack, Chip } from "@mui/material"
import { ExpandMore } from "@mui/icons-material"
import { GET_COMPANY_SESSION_CATEGORIES } from "../../queries";
import { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
interface CategoryRanking {
    rank: number;
    categoryTitle: string;
    total: number;
}

interface CategoryTypeRanking {
    questionId: string;
    questionTitle: string;
    rankings: CategoryRanking[];
    groupKey?: string;
}

interface CommonThemesProps {
    companyId: string;
}
const CommonThemes = ({ companyId }: CommonThemesProps) => {
    // const companyId = usePersonStore(state => state.company.id)
    const [expandedIndex, setExpandedIndex] = useState<string | false>(false);
    const { data, loading, error } = useQuery(GET_COMPANY_SESSION_CATEGORIES, {
        variables: { id: companyId }
    })

    const handleChange = (index: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
        // If clicking the already expanded item, close it; otherwise expand the clicked item
        setExpandedIndex(isExpanded ? index : false);
    };
    const categories: CategoryTypeRanking[] = data?.company?.companySessionCategories?.rankings ?? [];
    const questionTitleMap: Record<string, string> = {
        "What makes you happy?": "What makes you happy?",
        "What could make you happier?": "What could make you happier?",
        "What makes you tired during the school day?": "What makes you tired during the school day?",
        "If there were one thing in your life that you could change to make you less tired during the school day what would it be?": "What could make you less tired during the school day?",
        "If there was one thing that you could do to make your school life better what would it be?": "If there was one thing that you could do to make your school life better what would it be?",
        "If there was one thing that you could do to make your social life better what would it be?": "If there was one thing that you could do to make your social life at school better what would it be?",
        "What makes you tired on the weekend?": "What makes you tired on the weekend?",
        "If there were one thing in your life that you could change to make you less tired on the weekend what would it be?": "If there were one thing in your life that you could change to make you less tired on the weekend what would it be?",
        "What makes you sad?": "What makes you sad?",
        "What are your hobbies or special interests?": "What are your hobbies or special interests?",
        "Describe them": "What thoughts distract you or make it hard for you to concentrate",
        "What makes you feel nervous?": "What makes you feel nervous?",
        "If there was one thing in your life that you could change to make you feel less nervous what would it be?": "If there was one thing in your life that you could change to make you feel less nervous what would it be?",
        "What is your greatest worry or insecurity?": "What is your greatest worry or insecurity?",
        "Would you like to share what happened?": "Would you like to share what happened when you had thoughts/plans of suicide or feelings of hopelessness?",
        "What gives you energy?": "What gives you energy?",
        "What are your strengths, gifts, and talents?": "What are your strengths, gifts, and talents?",
    }
    const formatQuestionTitle = (title: string, groupKey?: string) => {
        const mapped = questionTitleMap[title];
        if (mapped) return mapped;

        if (title == "What happened? What did you do?") {
            if (groupKey === "WHAT_HAPPENED") return "Have any of your peers hurt you or made you feel bad, if so, what happened?";
            if (groupKey === "WHAT_DID_YOU_DO") return "Have any of your peers hurt you or made you feel bad, if so, what did you do?";
        }

        return title;
    };
    return (
        <Box>
            <Typography sx={{ paddingBottom: ".5rem", textAlign: "center" }}>
                Common Themes in Free Response Questions
            </Typography>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: 1,
                    columnGap: 3,
                }}
            >
                {categories.map((item, index) => {
                    const columns = 2; // adjust if needed
                    const row = Math.floor(index / columns);
                    const col = index % columns;

                    const isWhite = (row + col) % 2 === 0;
                    return (
                        <Box key={`${item.questionId}:${item.groupKey}`} sx={{
                            display: "flex", flexDirection: "column",
                        }}>
                            <Accordion
                                expanded={expandedIndex === `${item.questionId}:${item.groupKey}`}
                                onChange={handleChange(`${item.questionId}:${item.groupKey}`)}
                                sx={{
                                    backgroundColor: isWhite ? "white" : "gainsboro"
                                }}
                            >
                                <AccordionSummary expandIcon={<ExpandMore />}>
                                    <Typography>{formatQuestionTitle(item.questionTitle, item.groupKey)}</Typography>

                                </AccordionSummary>
                                <AccordionDetails>
                                    <Stack spacing={1}>
                                        {item.rankings.map((ranking, i) => (
                                            <Box
                                                key={i}
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                }}
                                            >
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                    <Chip
                                                        label={`#${ranking.rank}`}
                                                        size="small"
                                                        color="primary"
                                                        variant="outlined"
                                                    />
                                                    <Typography variant="body2">{ranking.categoryTitle}</Typography>
                                                </Box>
                                                <Chip
                                                    label={`${ranking.total} responses`}
                                                    size="small"
                                                    color="default"
                                                />
                                            </Box>
                                        ))}
                                    </Stack>
                                </AccordionDetails>
                            </Accordion>
                        </Box>)
                })}
                {/* {testItems.map((item, index) => (
                    <Box key={index} sx={{ display: "flex", flexDirection: "column" }}>
                        <Accordion
                            expanded={expandedIndex === item}
                            onChange={handleChange(item)}
                        >
                            <AccordionSummary expandIcon={<ExpandMore />}>
                                <Typography>{item}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    Nulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiat.
                                    Aliquam eget maximus est, id dignissim quam.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    </Box>
                ))} */}
            </Box>
        </Box>
    )
}

export default CommonThemes